import { useAmbassadorSnapshot, getNationalCrews, sponsorForNation } from "@/lib/ambassadors/ambassadorEngine";

export function NationalCrewsWidget() {
  useAmbassadorSnapshot();
  const crews = getNationalCrews();
  const max = Math.max(1, ...crews.map((c) => c.score));
  return (
    <section className="rounded-2xl border border-border/60 bg-background/60 p-3">
      <h3 className="text-sm font-black uppercase tracking-wider">⚔️ National Crews</h3>
      <ul className="mt-2 space-y-2">
        {crews.map((c) => {
          const pct = Math.round((c.score / max) * 100);
          const sp = sponsorForNation(c.nation);
          return (
            <li key={c.nation} className="rounded-xl border border-border/40 bg-background/50 p-2">
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2 min-w-0">
                  <span className="text-lg" aria-hidden>{c.flag}</span>
                  <div className="min-w-0">
                    <div className="truncate text-sm font-black">{c.name}</div>
                    <div className="text-[10px] text-muted-foreground">
                      {c.members} fans · ↗ {c.referrals} · 🔮 {c.predictions}
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-xs font-black tabular-nums">{c.score}</div>
                  {sp && (
                    <div className="text-[9px] font-bold uppercase tracking-wider" style={{ color: sp.hex }}>
                      ◆ {sp.brand}
                    </div>
                  )}
                </div>
              </div>
              <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-muted">
                <div
                  className="h-full rounded-full transition-all"
                  style={{ width: `${pct}%`, background: sp?.hex ?? "var(--primary)" }}
                />
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
